<template>
	<base-user-list
		v-loading="loading"
		show-filter
		title="Seznam uživatelů"
		:users="users"
		detail-link="eshop-user-edit"
		new-link="eshop-user-new"
		@get-page="loadData" />
</template>

<script>
import { BaseUserList } from '@/components/Base';

export default {
	name: 'EshopUserList',
	components: {
		BaseUserList,
	},
	data() {
		return {
			users: {},
			loading: false,
		};
	},
	methods: {
		async loadData(params) {
			this.loading = true;
			this.users = await this.$service.admin.getEshopUsers(params);
			this.loading = false;
		},
	},
};
</script>
